"use client"

import { useCallback, useEffect, useState } from "react"
import { shallow } from "zustand/shallow"
import { useHeaderStore } from "../../../../../store/header.store"

import style from "./ReportTotalQueries.module.css"
import styleForm from "../../../../../common/theme/styles/form.module.css"
import styleDataTable from "../../../../../common/UI/DataTable/dataTable.module.css";


import ProgressBar from "../../../../../common/UI/ProgressBar"
import useFormattedDate from "../../../../../common/hooks/useFormattedDate"

import ChartComponent from "../../../components/chart"
import InputSearch from "../../../../../common/UI/DataTable/inputSearch"
import { GetTotalConsultationsService } from "../../../services/Reports/getTotalConsultations.service"

import { subDays } from "date-fns"
import { GetAnalyticsFiltersService } from "../../../../../common/services/getAnalyticsFilters.service"
import { GetSessionsWithPaginationService } from "../../../services/Reports/getSessionsWithPagination.service"
import AppInputSearchFilter from "../../../../../common/UI/Inputs/appInputSearchFilter"
import AppButton from "../../../../../common/UI/Buttons/AppButton"
import { GetInquiryDetailsBySessionService } from "../../../services/dashboard/getInquiryDetailsBySession.service"
import Modal from "../../../../../common/UI/Modal"
import { ConversationViewer } from "../../../components/ConversationViewer"
import DataTable from "../../../../../common/UI/DataTable/dataTable"
import { GetWidgetsFilterWithPaginationService } from "../../../services/getWidgetsFilterWithPagination.service"
import { DataSelectDto } from "../../../../../common/dtos/general.dto"

const getSessionsWithPaginationService = new GetSessionsWithPaginationService()

interface ChannelValues {
  channelName: string
  values: number[]
}

interface InquiryAnalyticsResponse {
  dates: string[]
  channelValues: ChannelValues[]
}


interface ConversationMessage {
  inquiryId: string
  inquiryDate: string
  citizenId: string | null
  procedureTypeId: string | null
  question: string
  userInquiry: string
  inquiryForever: string
  inquiryDateTime: string
  inquiryGetDay: string
  inquiryStart: string
  inquiryGetMinute: string
  responseGeneratedDate: string
  responseGenerated: string
  userFeedback: string | null
}

// Interface para la respuesta del servicio de conversación


export default function ReportTotalQueriesPage() {
  const headerStore = useHeaderStore(
    (state) => ({
      setModule: state.setModule,
      setModuleItem: state.setModuleItem,
    }),
    shallow,
  )

  const [isReloadData, setIsReloadData] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const hFormatDate = useFormattedDate()
  const today = new Date()
  const [loading, setLoading] = useState(false)
  const [startDateTotalConsultations, setStartDateTotalConsultations] = useState<any>(subDays(today, 7))
  const [endDateTotalConsultations, setEndDateTotalConsultations] = useState<any>(today)
  const [responseDataGraphTotalConsultations, setResponseDataGraphTotalConsultations] =
    useState<InquiryAnalyticsResponse | null>(null)

  const [dataGraphSessionTotalConsultations, setDataGraphTotalConsultations] = useState<any[]>([])
  const [dataGraphoptionsTotalConsultations, setDataGraphoptionsTotalConsultations] = useState<any>({})
  const [dataChannels, setDataChannels] = useState<any[]>([])
  const [selectChannels, setSelectChannels] = useState<{ label: string; value: number }[]>([])
  const [dataCountsTypes, setDataCountsTypes] = useState<any>({})
  const [selectCountsTypes, setSelectCountsTypes] = useState<{ label: string; value: string } | null>(null)
  const [widgetFilter, setWidgetFilter] = useState<DataSelectDto>({
    label: '',
    value: ''
  });
  // Estados para el modal de conversación
  const [conversationMessages, setConversationMessages] = useState<ConversationMessage[]>([])
  const [loadingConversation, setLoadingConversation] = useState(false)

  const getDataTotalConsultations = useCallback(async () => {
    setLoading(true)
    const params = {
      startDate: startDateTotalConsultations ? hFormatDate(startDateTotalConsultations, "yyyy-MM-dd") : "",
      endDate: endDateTotalConsultations ? hFormatDate(endDateTotalConsultations, "yyyy-MM-dd") : "",
      channelIds: selectChannels.map((c: any) => c.value),
      status: selectCountsTypes ? selectCountsTypes.value : "",
      widgetId: widgetFilter ? widgetFilter.value : "",

    }
    setIsReloadData(!isReloadData)

    try {
      const response = await GetTotalConsultationsService(params)
      setResponseDataGraphTotalConsultations(response || null)
    } catch (error) {
      console.error("Error fetching total consultations:", error)
      setResponseDataGraphTotalConsultations(null)
    } finally {
      setLoading(false)
    }
  }, [endDateTotalConsultations, selectChannels, selectCountsTypes, widgetFilter])

  const serviceAllWidgets = useCallback(async (value: string) => {
    const response: any = await GetWidgetsFilterWithPaginationService({
      search: value,
      perPage: 100
    });
    return response.data.map((item: any) => ({
      label: item.name,
      value: item.widgetId,
    }));
  }, []);
  const getAllAnalyticsFiltersChannels = async () => {
    const response: any = await GetAnalyticsFiltersService()
    setDataChannels(
      response.channels.map((item: any) => ({
        label: item.channelName,
        value: item.channelId,
      })),
    )
  }

  const getAllAnalyticsFiltersCountsTypes = async () => {
    const response: any = await GetAnalyticsFiltersService()
    setDataCountsTypes(
      response.statusInquiry.map((item: any) => ({
        label: item.label,
        value: item.value,
      })),
    )
  }

  useEffect(() => {
    if (startDateTotalConsultations && endDateTotalConsultations) {
      getDataTotalConsultations()
      setIsReloadData(!isReloadData)
    }
  }, [endDateTotalConsultations, selectChannels, selectCountsTypes, widgetFilter])


  useEffect(() => {
    headerStore.setModule("Reportes", "")
    headerStore.setModuleItem("Total consultas", "/admin/home")
    getAllAnalyticsFiltersChannels()
    getAllAnalyticsFiltersCountsTypes()
  }, [])
  // Helper para leer la var CSS
  const readOnSurface = () =>
    getComputedStyle(document.documentElement)
      .getPropertyValue('--color-on-surface-variant-main')
      .trim() || '#22356a';

  const [onSurface, setOnSurface] = useState(readOnSurface());

  // Observa cambios en class/data-theme/style del <html> (o donde cambies el tema)
  useEffect(() => {
    const el = document.documentElement;
    const update = () => {
      const next = readOnSurface();
      setOnSurface(prev => (prev !== next ? next : prev));
    };
    const obs = new MutationObserver(update);
    obs.observe(el, { attributes: true, attributeFilter: ['class', 'data-theme', 'style'] });

    update(); // primer chequeo
    return () => obs.disconnect();
  }, []);

  useEffect(() => {
    if (!responseDataGraphTotalConsultations) return;

    const formattedDates = responseDataGraphTotalConsultations.dates.map((date: string) =>
      hFormatDate(date, "dd-MM-yyyy")
    );

    const channelData = responseDataGraphTotalConsultations.channelValues.map((channel: ChannelValues) => ({
      name: channel.channelName,
      data: channel.values.map((value) => Number(value) || 0),
    }));

    const numSeries = channelData.length;
    setDataGraphTotalConsultations(channelData);

    setDataGraphoptionsTotalConsultations({
      chart: {
        type: "area",
        height: 350,
        foreColor: onSurface,
        zoom: { enabled: true, type: "x", autoScaleYaxis: true },
        toolbar: {
          show: true,
          tools: { download: true, selection: true, zoom: true, zoomin: true, zoomout: true, pan: true, reset: true },
          autoSelected: "zoom",
        },
      },
      theme: { palette: "palette8" },
      stroke: { curve: "straight", width: Array(numSeries).fill(3), dashArray: Array(numSeries).fill(0) },
      markers: { size: 5, hover: { sizeOffset: 3 } },
      xaxis: {
        categories: formattedDates,
        labels: { rotate: -60, style: { fontSize: "10px", colors: onSurface } },
        title: { text: "Fechas", style: { fontSize: "12px", color: onSurface } },
      },
      yaxis: {
        min: 0,
        decimalsInFloat: 0,
        labels: { formatter: (val?: number) => (val != null ? val.toFixed(0) : "0"), style: { fontSize: "12px", colors: onSurface } },
        forceNiceScale: false,
        title: { text: "Total #", style: { fontSize: "12px", color: onSurface } },
      },
      legend: {
        show: true,
        position: "bottom",
        horizontalAlign: "center",
        labels: { colors: onSurface },
        formatter: (_: string, opts: { seriesIndex: number }) => channelData[opts.seriesIndex]?.name ?? "Canal",
      },
      tooltip: { style: { fontSize: '12px', fontFamily: 'inherit' } },
      grid: { borderColor: onSurface.startsWith('#') ? `${onSurface}22` : undefined },
    });
  }, [responseDataGraphTotalConsultations, onSurface]); // <-- agrega onSurface


  const columns = [
    {
      header: "ID SESIÓN",
      field: "sessionId",
      render: (row: any) => {
        return (
          <div style={{ width: '200px' }}
          >{row.sessionId}</div>
        )
      }
    },
    {
      header: "FECHA INICIO",
      field: "",
      render: (row: any) => {
        return <>{row.startDate ? <div>{hFormatDate(row.startDate, "dd-MM-yyyy hh:mm:ss a")}</div> : ""}</>
      },
    },
    {
      header: "ESTADO",
      field: "status",
    },
    {
      header: "WIDGET ID",
      field: "widgetId",
    },
    {
      header: "CÓDIGO CIUDADANO",
      field: "",
      render: (row: any) => {
        return <>{row.citizen ? <div>{row.citizen.externalChannelId}</div> : ""}</>
      },
    },
    {
      header: "CANAL",
      field: "",
      render: (row: any) => {
        return <>{row.citizen ? <div>{row.citizen.communicationChannel?.channelName}</div> : ""}</>
      },
    },
    {
      header: "OPCIONES",
      field: "",
      render: (row: any) => (
        <AppButton
          className={styleDataTable.buttom_option}
          variant="primary"
          iconName="edit"
          buttonText="Ver Conversación"
          onClick={() => handleView(row)}
        />
      ),
    },
  ]


  const handleView = async (row: any) => {
    // Validate that row has the required data
    if (!row || !row.sessionId) {
      console.error("Invalid session data:", row)
      return
    }

    setIsOpen(true)
    setLoadingConversation(true)
    setConversationMessages([])

    try {
      const params = {
        sessionId: row.sessionId,
      }
      const response: any = await GetInquiryDetailsBySessionService(params)
      // Handle the specific response structure from the API
      setConversationMessages(response)
    } catch (error) {
      console.error("Error fetching conversation details:", error)
      setConversationMessages([])
    } finally {
      setLoadingConversation(false)
    }
  }
  const handleCloseModal = () => {
    setIsOpen(false)
    setConversationMessages([])
    setLoadingConversation(false)
  }
  return (
    <div className={style.Dashboard_page}>
      <h4 className={style.under__line}>
        <strong>Número total de consultas:</strong>
      </h4>

      {loading && <ProgressBar />}

      <div className={style.containerGraph} style={{ marginTop: "0.5rem" }}>
        <div className={style.containerFilters}>
          <div>
            <AppInputSearchFilter
              name="channels"
              textLabel="Selecciona canal"
              data={dataChannels}
              selected={selectChannels}
              onSelect={setSelectChannels}
              multiple={true}
            />
          </div>
          <div style={{ maxWidth: 260 }}>
            <InputSearch
              classNameInput={styleForm.input__input}
              key={crypto.randomUUID()}
              textLabel="Selecciona estado"
              data={dataCountsTypes}
              selected={selectCountsTypes}
              onSelect={setSelectCountsTypes}
            />
          </div>
          <div
            className={style.container__select}
            style={{ minWidth: "280px" }}
          >
            <InputSearch
              key={crypto.randomUUID()}
              name="status"
              classNameInput={styleForm.input__input}
              textLabel="Selecciona widget"
              serviceCall={serviceAllWidgets}
              onSelect={(selected) => {
                setWidgetFilter(selected);
              }}
              selected={widgetFilter}
            />
          </div>
        </div>

        <ChartComponent
          key={`success-rate-${onSurface}`}   // <-- remount cuando cambie el color
          titleChart="Total de consultas"
          typeGraph="bar"
          dataDashboard={dataGraphSessionTotalConsultations}
          dataOptions={dataGraphoptionsTotalConsultations}
          onDateChange={(dateRange) => {
            if (dateRange) {
              setStartDateTotalConsultations(dateRange[0])
              setEndDateTotalConsultations(dateRange[1])
            }
          }}
        />

        <DataTable
          title="Listado de sesiones"
          columns={columns}
          service={getSessionsWithPaginationService}
          reloadData={isReloadData}
          // addButton={addButton}
          showSearch={false}
          params={{
            startDate: startDateTotalConsultations ? hFormatDate(startDateTotalConsultations, "yyyy-MM-dd") : "",
            endDate: endDateTotalConsultations ? hFormatDate(endDateTotalConsultations, "yyyy-MM-dd") : "",
            channelIds: selectChannels.map(c => c.value),
            status: selectCountsTypes ? selectCountsTypes.value : "",
            widgetId: widgetFilter ? widgetFilter.value : "",
          }}
          excelButton={{
            enabled: true,
            nameFile: `Lista de Sesiones`,
            getExcelData: (data) => {
              return data.map((row: any) => ({
                ID_SESIÓN: row.sessionId ?? "",
                FECHA_INICIO: row.startDate
                  ? hFormatDate(row.startDate, "dd-MM-yyyy hh:mm:ss a") // o new Date(row.startDate) si quieres celda de fecha real
                  : "",
                ESTADO: row.status ?? "",
                WIDGET_ID: row.widgetId ?? "",
                CÓDIGO_CIUDADANO: row.citizen?.externalChannelId ?? "",
                CANAL: row.citizen?.communicationChannel?.channelName ?? "",
              }));
            },
          }}
        >
          {''}
        </DataTable>

        <Modal
          title="Detalle de Conversación"
          isOpen={isOpen}
          onClose={handleCloseModal}
          size={{ width: "90%", maxWidth: "1400px", height: "80vh" }}
          loadingModal={false}
          footerContent={
            <div className={style.containerButtoms}>
              <button className={styleForm.buttomFooter + " " + styleForm.buttom_cancelar} onClick={handleCloseModal}>
                Cerrar
              </button>
            </div>
          }
        >
          {/* {selectedSessionData && ( */}
          <ConversationViewer
            messages={conversationMessages}
            loading={loadingConversation}
          />
          {/* )} */}
        </Modal>
      </div>
    </div>
  )
}
